// extracted by mini-css-extract-plugin
export default {"banerWrap":"GeolocationBaner_banerWrap__P7JGY","closeBaner":"GeolocationBaner_closeBaner__2duwX"};